import React from 'react'

const SvgInstagram = ({ fill = '#333333' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='14'
    height='14.000004768371582'
    viewBox='0 0 14 14.000004768371582'
  >
    <defs>
      <clipPath id='master_svg0_102_7366'>
        <rect x='0' y='0' width='14' height='14.000004768371582' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_102_7366)'>
      <g>
        <ellipse
          cx='6.998553514480591'
          cy='6.998553514480591'
          rx='2.850116014480591'
          ry='2.850116014480591'
          fill={fill}
          fillOpacity='1'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
      <g>
        <path
          d='M13.6573,1.96259C13.5037,1.56651,13.3146,1.27714,13.0187,0.981292C12.7164,0.678984,12.4335,0.496304,12.0374,0.342724C11.7351,0.224711,11.2857,0.0889126,10.4531,0.0468811C9.55427,0.00484969,9.28268,0,7,0C4.71732,0,4.44573,0.00646543,3.54688,0.0468811C2.7127,0.0824472,2.26328,0.224711,1.96259,0.342724C1.56651,0.496304,1.27714,0.685449,0.981295,0.981292C0.678986,1.2836,0.496306,1.56651,0.342724,1.96259C0.224709,2.2649,0.0889126,2.71432,0.0468836,3.54688C0.00484969,4.44573,0,4.71732,0,7C0,9.28268,0.0064679,9.55428,0.0468836,10.4531C0.0824496,11.2873,0.224714,11.7367,0.342724,12.0374C0.496306,12.4335,0.685449,12.7229,0.981295,13.0187C1.2836,13.321,1.56651,13.5037,1.96259,13.6573C2.2649,13.7753,2.71432,13.9111,3.54688,13.9531C4.44573,13.9952,4.71732,14,7,14C9.28268,14,9.55427,13.9935,10.4531,13.9531C11.2873,13.9176,11.7367,13.7753,12.0374,13.6573C12.4335,13.5037,12.7229,13.3146,13.0187,13.0187C13.321,12.7164,13.5037,12.4335,13.6573,12.0374C13.7753,11.7351,13.9111,11.2857,13.9531,10.4531C13.9951,9.55427,14,9.28268,14,7C14,4.71732,13.9935,4.44573,13.9531,3.54688C13.9176,2.71432,13.7753,2.2649,13.6573,1.96259ZM6.99838,11.394C4.57344,11.394,2.61085,9.43141,2.61085,7.00647C2.61085,4.58152,4.57344,2.61894,6.99838,2.61894C9.42332,2.61894,11.3859,4.58152,11.3859,7.00647C11.3859,9.42494,9.41686,11.394,6.99838,11.394ZM11.5573,3.46443C10.9898,3.46443,10.534,3.00369,10.534,2.44111C10.534,1.87367,10.9947,1.41778,11.5573,1.41778C12.1247,1.41778,12.5806,1.87852,12.5806,2.44111C12.5871,3.00855,12.1247,3.46443,11.5573,3.46443Z'
          fill={fill}
          fillOpacity='1'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
    </g>
  </svg>
)

export default SvgInstagram
